[
  "Afghanistan",
  "Afrique du Sud",
  "Albanie",
  "Algérie",
  "Allemagne",
  "Andorre",
  "Angola",
  "Anguilla",
  "Antarctique",
  "Antigua-et-Barbuda",
  "Arabie saoudite",
  "Argentine",
  "Arménie",
  "Aruba",
  "Australie",
  "Autriche",
  "Azerbaïdjan",
  "Bahamas",
  "Bahreïn",
  "Bangladesh",
  "Barbade",
  "Belgique",
  "Belize",
  "Bénin",
  "Bermudes",
  "Bhoutan",
  "Biélorussie",
  "Birmanie",
  "Bolivie",
  "Bosnie-Herzégovine",
  "Botswana",
  "Brésil",
  "Brunei",
  "Bulgarie",
  "Burkina Faso",
  "Burundi",
  "Cambodge",
  "Cameroun",
  "Canada",
  "Cap-Vert",
  "Chili",
  "Chine",
  "Chypre",
  "Colombie",
  "Comores",
  "Corée du Nord",
  "Corée du Sud",
  "Costa Rica",
  "Côte d'Ivoire",
  "Croatie",
  "Cuba",
  "Curaçao",
  "Danemark",
  "Djibouti",
  "Dominique",
  "Égypte",
  "Émirats arabes unis",
  "Équateur",
  "Érythrée",
  "Espagne",
  "Estonie",
  "Eswatini",
  "États fédérés de Micronésie",
  "États-Unis",
  "Éthiopie",
  "Fidji",
  "Finlande",
  "France",
  "Gabon",
  "Gambie",
  "Géorgie",
  "Géorgie du Sud-et-les îles Sandwich du Sud",
  "Ghana",
  "Gibraltar",
  "Grèce",
  "Grenade",
  "Groenland",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guernesey",
  "Guinée",
  "Guinée équatoriale",
  "Guinée-Bissau",
  "Guyana",
  "Guyane",
  "Haïti",
  "Honduras",
  "Hong Kong",
  "Hongrie",
  "Île Bouvet",
  "Île Christmas",
  "Île de Man",
  "Île Norfolk",
  "Îles Åland",
  "Îles Caïmans",
  "Îles Cocos",
  "Îles Cook",
  "Îles Féroé",
  "Îles Heard-et-MacDonald",
  "Îles Malouines",
  "Îles Mariannes du Nord",
  "Îles Marshall",
  "Îles mineures éloignées des États-Unis",
  "Îles Pitcairn",
  "Îles Salomon",
  "Îles Turques-et-Caïques",
  "Îles Vierges britanniques",
  "Îles Vierges des États-Unis",
  "Inde",
  "Indonésie",
  "Irak",
  "Iran",
  "Irlande",
  "Islande",
  "Israël",
  "Italie",
  "Jamaïque",
  "Japon",
  "Jersey",
  "Jordanie",
  "Kazakhstan",
  "Kenya",
  "Kirghizistan",
  "Kiribati",
  "Koweït",
  "La Réunion",
  "Laos",
  "Lesotho",
  "Lettonie",
  "Liban",
  "Liberia",
  "Libye",
  "Liechtenstein",
  "Lituanie",
  "Luxembourg",
  "Macao",
  "Macédoine du Nord",
  "Madagascar",
  "Malaisie",
  "Malawi",
  "Maldives",
  "Mali",
  "Malte",
  "Maroc",
  "Martinique",
  "Maurice",
  "Mauritanie",
  "Mayotte",
  "Mexique",
  "Moldavie",
  "Monaco",
  "Mongolie",
  "Monténégro",
  "Montserrat",
  "Mozambique",
  "Namibie",
  "Nauru",
  "Népal",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Niue",
  "Norvège",
  "Nouvelle-Calédonie",
  "Nouvelle-Zélande",
  "Oman",
  "Ouganda",
  "Ouzbékistan",
  "Pakistan",
  "Palaos",
  "Palestine",
  "Panama",
  "Papouasie-Nouvelle-Guinée",
  "Paraguay",
  "Pays-Bas",
  "Pays-Bas caribéens",
  "Pérou",
  "Philippines",
  "Pologne",
  "Polynésie française",
  "Porto Rico",
  "Portugal",
  "Qatar",
  "République arabe sahraouie démocratique",
  "République centrafricaine",
  "République démocratique du Congo",
  "République dominicaine",
  "République du Congo",
  "Roumanie",
  "Royaume-Uni",
  "Russie",
  "Rwanda",
  "Saint-Barthélemy",
  "Saint-Christophe-et-Niévès",
  "Saint-Marin",
  "Saint-Martin",
  "Saint-Pierre-et-Miquelon",
  "Saint-Siège (État de la Cité du Vatican)",
  "Saint-Vincent-et-les-Grenadines",
  "Sainte-Hélène, Ascension et Tristan da Cunha",
  "Sainte-Lucie",
  "Salvador",
  "Samoa",
  "Samoa américaines",
  "Sao Tomé-et-Principe",
  "Sénégal",
  "Serbie",
  "Seychelles",
  "Sierra Leone",
  "Singapour",
  "Slovaquie",
  "Slovénie",
  "Somalie",
  "Soudan",
  "Soudan du Sud",
  "Sri Lanka",
  "Suède",
  "Suisse",
  "Suriname",
  "Svalbard et île Jan Mayen",
  "Syrie",
  "Tadjikistan",
  "Taïwan (République de Chine)",
  "Tanzanie",
  "Tchad",
  "Tchéquie",
  "Terres australes et antarctiques françaises",
  "Territoire britannique de l'océan Indien",
  "Thaïlande",
  "Timor oriental",
  "Togo",
  "Tokelau",
  "Tonga",
  "Trinité-et-Tobago",
  "Tunisie",
  "Turkménistan",
  "Turquie",
  "Tuvalu",
  "Ukraine",
  "Uruguay",
  "Vanuatu",
  "Venezuela",
  "Viêt Nam",
  "Wallis-et-Futuna",
  "Yémen",
  "Zambie",
  "Zimbabwe"
]
